import { render, staticRenderFns } from "./Provider.vue?vue&type=template&id=1af837ab&lang=pug&"
import script from "./Provider.vue?vue&type=script&lang=js&"
export * from "./Provider.vue?vue&type=script&lang=js&"
import style0 from "./Provider.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/danielrubiocastillo/Documents/workspaces/emaraplay/lobby-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1af837ab')) {
      api.createRecord('1af837ab', component.options)
    } else {
      api.reload('1af837ab', component.options)
    }
    module.hot.accept("./Provider.vue?vue&type=template&id=1af837ab&lang=pug&", function () {
      api.rerender('1af837ab', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Provider.vue"
export default component.exports